import React from "react";
import Navigation from "./navBar";
import { useNavigate } from "react-router-dom";

const HeaderComp = () => {
    const navigate = useNavigate();

    const navigateTo = (location: string) => {
        navigate(location);
    }

    return (
        <div className="bl-header">
            <div className="bl-nav">
                <Navigation signIn={true} />
            </div>
            <div className="bl-header-banner">
                <a href="/" style={{"display": "inline-block", "zIndex": "999", "position": "relative"}}><img onClick={() => navigateTo('/')} src={`${process.env.PUBLIC_URL}/img/Logo.png`} alt="Logo" className="logo-img" /></a>
                {/* <img src="./img/cover-img.jpg" className="img-responsive" style={{"width" : "100%"}} alt="Cover image"/> */}
            </div>
            <div className="bl-header-bottom"></div>
        </div>
    )
}

export default HeaderComp;